import { useQuery } from "@tanstack/react-query";

import { parseAuthResult } from "./amplify/amplify.helpers";
import { Auth } from "./isomorphic-auth/isomorphic-auth";

// Admin two-factor sign-in (OMG-2777). omg-api decides whether admin calls need
// it (ADMIN_MFA); this side only asks Cognito whether the signed-in admin has
// an authenticator app (TOTP) turned on, to prompt them to set one up.

export const TWO_FACTOR_PATH = "/two-factor";
export const ADMIN_MFA_REQUIRED = "ADMIN_MFA_REQUIRED";

/** The authenticator app's label for the account. Prod keeps the plain name
 *  it has always had; every other stage carries its name, so a UAT entry is
 *  not mistaken for the Prod one. */
export const totpAppName = (stage: string | undefined) =>
  stage === "Prod" ? "OMGYES Admin" : `OMGYES Admin (${stage || "local"})`;

export const TOTP_APP_NAME = totpAppName(import.meta.env.VITE_APP_STAGE);

export const twoFactorQueryKey = ["auth", "mfa-preference"] as const;

export const useTotpEnabled = () =>
  useQuery({
    queryKey: twoFactorQueryKey,
    queryFn: async () => {
      const preference = parseAuthResult(await Auth.fetchMfaPreference());
      return preference.enabled?.includes("TOTP") ?? false;
    },
    staleTime: 5 * 60 * 1000,
  });
